module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('LiberarASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('DownloadASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('UploadASO', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('LembreteAssinatura', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('HistoricoWhatsapp', {
    attrs: {
      "parent": this
    }
  }), _vm._v(" "), _c('TableView', {
    attrs: {
      "registerName": "Upload de ASO",
      "registerIcon": "fa fa-upload",
      "registerTitle": "Clique aqui para fazer o upload dos ASO e liberar posteriormente",
      "onSearch": _vm.getConsulta,
      "onFilter": _vm.getConsulta,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "onRegister": _vm.validarPermissao(553) ? _vm.onRegister : null,
      "filterBadge": _vm.filterBadge,
      "response": _vm.response,
      "disableCheckAll": ""
    }
  }, [(_vm.validarPermissao(561)) ? _c('div', {
    attrs: {
      "slot": "table-button"
    },
    slot: "table-button"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-paper-plane",
      "type": "warning",
      "value": "Enviar ASO por Email"
    },
    on: {
      "click": function($event) {
        return _vm.onDownloadASO(null)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "search-detail"
    },
    slot: "search-detail"
  }, [_vm._v("Busca por código da consulta, nome do funcionário ou empresa")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('ed-form', {
    attrs: {
      "data": _vm.formFilter,
      "config": _vm.config,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d6ee73a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/consulta/liberacao/index.vue
// module id = 1525
// module chunks = 45